<div *ngFor="let arrayField of field.fieldGroup; let i = index" class="card mb-4">
  <div [class.card-collapsible]="props.collapsible" (click)="toggleCollapse($event, i)" class="card-header d-flex">
    <span class="flex-grow-1">
      {{ arrayField.props.label }}
    </span>

    <button
      *ngIf="props.collapsible"
      (click)="toggleCollapse($event, i)"
      class="btn btn-link me-3 mb-0 btn-toggle-collapse w-auto"
    >
      <fa-icon [icon]="collapsedIndexes.includes(i) ? 'angle-down' : 'angle-up'"></fa-icon>
    </button>

    <button
      *ngIf="field.fieldGroup.length > 1 && mayRemove(i)"
      (click)="remove(i)"
      class="btn btn-link btn-remove w-auto"
    >
      <fa-icon icon="trash"></fa-icon>
    </button>
  </div>

  <div
    [class.overflow-hidden]="props.collapsible && collapsedIndexes.includes(i)"
    class="card-body"
    [@collapse]="props.collapsible && collapsedIndexes.includes(i) ? 'collapsed' : 'expanded'"
  >
    <formly-group [field]="arrayField"></formly-group>
  </div>
</div>

<button *ngIf="mayAdd()" (click)="add()" class="btn btn-link w-100">
  <ng-container *ngIf="props.addLabel; else noAddLabelTemplate">
    {{ props.addLabel }}
  </ng-container>
  <ng-template #noAddLabelTemplate>
    {{ "Add another" | translate }}
  </ng-template>
</button>
